function formatBytes(bytes: number, decimals = 0): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function maxFilesSize(files, size: number) {
  if(!files) {
    return {
      isValid: true,
      errorMessage: '',
    };
  };

  const reducer = (accumulator, currentValue) =>
    accumulator + currentValue.size;
  const totalSize = files.reduce(reducer, 0);

  const isValid = totalSize < size;
  const errorMessage = !isValid
    ? `Superó el peso máximo, ¡sólo se acepta ${formatBytes(size, 1)}!`
    : null;

  return {
    isValid,
    errorMessage,
  };
}

function acceptExtNamesFiles(files, acceptExtNames) {
  if(!files) {
    return {
      isValid: true,
      errorMessage: '',
    };
  };

  const isValidExtName = files.reduce((previous: boolean, file: File) => {
    if (!previous) return previous;

    const fileExtName = file.name.split('.').pop();
    previous = acceptExtNames.some((validExtName) => {
      return validExtName == fileExtName?.toLowerCase();
    });

    return previous;
  }, true);

  const extNames = acceptExtNames.join('/');

  const errorMessage = !isValidExtName
    ? `Sólo se aceptan formatos ${extNames}`
    : null;

  return {
    isValid: isValidExtName,
    errorMessage,
  };
}

export { maxFilesSize, acceptExtNamesFiles, formatBytes };
